const roles = ['subuser', 'user', 'admin'];

export default roles